import { render, staticRenderFns } from "./MsgGreen.vue?vue&type=template&id=882024f2&scoped=true"
import script from "./MsgGreen.vue?vue&type=script&lang=js"
export * from "./MsgGreen.vue?vue&type=script&lang=js"
import style0 from "./MsgGreen.vue?vue&type=style&index=0&id=882024f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882024f2",
  null
  
)

export default component.exports